import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { readConsent, updateConsent, CONSENT_STORAGE_KEY } from "@/lib/consent";

const CookieBanner = () => {
  const { t, localePath } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const existing = readConsent();
    if (!existing) setVisible(true);
  }, []);

  const handle = (granted) => {
    updateConsent(granted);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 sm:pb-6"
      role="dialog"
      aria-live="polite"
      aria-label={t("cookies.banner.title")}
    >
      <div className="max-w-6xl mx-auto bg-white border border-slate-300 shadow-xl">
        <div className="p-5 sm:p-6 grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-5 items-start lg:items-center">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#C85A32]">
              {t("cookies.banner.title")}
            </p>
            <p className="mt-2 text-sm text-slate-700 leading-relaxed">
              {t("cookies.banner.message")}{" "}
              <Link
                to={localePath("/cookies")}
                data-testid="cookie-banner-policy-link"
                className="underline text-[#0B2545] font-medium"
              >
                {t("cookies.banner.manage")}
              </Link>
              .
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-2 sm:justify-end">
            <button
              type="button"
              data-testid="cookie-banner-reject"
              onClick={() => handle(false)}
              className="px-4 py-2.5 text-sm font-semibold text-[#0B2545] border border-[#0B2545] hover:bg-[#0B2545] hover:text-white"
            >
              {t("cookies.banner.reject")}
            </button>
            <button
              type="button"
              data-testid="cookie-banner-accept"
              onClick={() => handle(true)}
              className="px-4 py-2.5 text-sm font-semibold text-white bg-[#C85A32] hover:bg-[#B24C27]"
            >
              {t("cookies.banner.accept")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
